import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationen from './locales/en.json';

import translationzhHK from './locales/zh-HK.json';



i18n

.use(Backend)

.use(LanguageDetector)

.use(initReactI18next)

.init({
lng: 'zh-HK',
fallbackLng: 'en',
debug: false,

interpolation: {
escapeValue: false,
},
resources: {

"en": {
translation: translationen
},

"zh-HK": {
translation: translationzhHK
},



}
});


export default i18n;